<template>
  <div class="menue">
    <!-- Liste der Materialien -->
    <div v-for="m in materials" :key="m.id" class="mitarbeiter">
  <span>{{ m.produktname }} - {{ m.produktnummer }} - {{ m.preis }} € - Bestand: {{ m.bestand }} - Einzelanfertigung: {{ m.einzelanfertigung ? 'Ja' : 'Nein' }}</span>
  <div class="button-container">
    <button @click="openEditPopup(m)" class="edit-btn">Bearbeiten</button>
    <button @click="openDeletePopup(m.id)" class="delete-btn">Löschen</button>
  </div>
</div>

    <button class="add-btn" @click="showPopupAdd = true">Material hinzufügen</button>

    <!-- Popup für das Hinzufügen von Material -->
    <div v-if="showPopupAdd" class="popup">
      <div class="popup-content">
        <h2>Material hinzufügen</h2>
        <div class="input-field">
          <label>Material Name(n):</label>
          <input v-model="newMaterial.produktname" placeholder="Materialname(n)" class="input-field" />
        </div>
        <div class="input-field">
          <label>Preis (€):</label>
          <input v-model="newMaterial.preis" type="number" step="0.01" placeholder="Preis" class="input-field" />
        </div>
        <div class="input-field">
          <label>Produktnummer:</label>
          <input v-model="newMaterial.produktnummer" placeholder="Produktnummer" class="input-field" />
        </div>
        <div class="input-field">
          <label>Bestand:</label>
          <input v-model="newMaterial.bestand" type="number" step="1" placeholder="Bestand" class="input-field" />
        </div>
        <div class="input-field">
          <label>Informationen:</label>
          <textarea v-model="newMaterial.info" placeholder="Zusätzliche Informationen (optional)" class="input-field"></textarea>
        </div>
        <!-- Neue Checkbox für Einzelanfertigung -->
        <div class="input-field">
          <label>
            <input type="checkbox" v-model="newMaterial.einzelanfertigung" /> Einzelanfertigung
          </label>
        </div>
        <div class="button-group">
          <button class="btn" @click="addMaterial">Hinzufügen</button>
          <button class="close-btn" @click="showPopupAdd = false">Schließen</button>
        </div>
      </div>
    </div>

    <!-- Popup zum Bearbeiten von Material -->
    <div v-if="showPopupEdit" class="popup">
      <div class="popup-content">
        <h2>Material bearbeiten</h2>
        <div class="input-field">
          <label>Material Name(n):</label>
          <input v-model="editMaterial.produktname" placeholder="Materialname(n)" class="input-field" />
        </div>
        <div class="input-field">
          <label>Preis (€):</label>
          <input v-model="editMaterial.preis" type="number" step="0.01" placeholder="Preis" class="input-field" />
        </div>
        <div class="input-field">
          <label>Produktnummer:</label>
          <input v-model="editMaterial.produktnummer" placeholder="Produktnummer" class="input-field" />
        </div>
        <div class="input-field">
          <label>Bestand:</label>
          <input v-model="editMaterial.bestand" type="number" step="1" placeholder="Bestand" class="input-field" />
        </div>
        <div class="input-field">
          <label>Informationen:</label>
          <textarea v-model="editMaterial.info" placeholder="Zusätzliche Informationen (optional)" class="input-field"></textarea>
        </div>
        <!-- Neue Checkbox für Einzelanfertigung -->
        <div class="input-field">
          <label>
            <input type="checkbox" v-model="editMaterial.einzelanfertigung" /> Einzelanfertigung
          </label>
        </div>
        <div class="button-group">
          <button class="btn" @click="updateMaterial">Speichern</button>
          <button class="close-btn" @click="showPopupEdit = false">Schließen</button>
        </div>
      </div>
    </div>

    <!-- Bestätigungs-Popup für das Löschen -->
    <div v-if="showPopupDelete" class="popup">
      <div class="popup-content">
        <h2>Löschen bestätigen</h2>
        <p>Möchten Sie dieses Material wirklich löschen?</p>
        <div class="button-group">
          <button class="btn" @click="confirmDelete">Ja, löschen</button>
          <button class="close-btn" @click="showPopupDelete = false">Abbrechen</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { ref, onMounted } from "vue";
import axios from "axios";
import { keycloak, initKeycloak } from '../../keycloak'; // Zwei Level nach oben


export default {
  setup() {
    const materials = ref([]);
    const showPopupAdd = ref(false);
    const showPopupEdit = ref(false);
    const showPopupDelete = ref(false);

    const newMaterial = ref({
      produktname: "",
      preis: null,
      produktnummer: "",
      bestand: null,
      info: "",
      einzelanfertigung: false, // Neues Feld für Einzelanfertigung
    });

    const editMaterial = ref({
      id: '',
      produktname: "",
      preis: null,
      produktnummer: "",
      bestand: null,
      info: "",
      einzelanfertigung: false, // Neues Feld für Einzelanfertigung
    });

    const materialToDelete = ref(null);

    axios.interceptors.request.use(config => {
      config.headers['Authorization'] = `Bearer ${keycloak.token}`;
      return config;
    }, error => {
      return Promise.reject(error);
    });

    const loadMaterial = async () => {
      try {
        const response = await axios.get("/api/materials");
        materials.value = response.data;
      } catch (error) {
        console.error("Fehler beim Laden der Materialien:", error.response?.data || error);
      }
    };

    const addMaterial = async () => {
      try {
        const response = await axios.post("/api/materials", newMaterial.value);
        materials.value.push(response.data);
        newMaterial.value = {
          produktname: "",
          preis: null,
          produktnummer: "",
          bestand: null,
          info: "",
          einzelanfertigung: false,
        };
        showPopupAdd.value = false;
      } catch (error) {
        console.error("Fehler beim Hinzufügen des Materials:", error.response?.data || error);
      }
    };

    const openEditPopup = (material) => {
      editMaterial.value = { ...material };
      showPopupEdit.value = true;
    };

    const updateMaterial = async () => {
      try {
        await axios.put(`/api/materials/${editMaterial.value.id}`, editMaterial.value);
        const index = materials.value.findIndex((m) => m.id === editMaterial.value.id);
        if (index !== -1) {
          materials.value[index] = { ...editMaterial.value };
        }
        showPopupEdit.value = false;
      } catch (error) {
        console.error("Fehler beim Bearbeiten des Materials:", error.response?.data || error);
      }
    };

    const openDeletePopup = (id) => {
      materialToDelete.value = id;
      showPopupDelete.value = true;
    };

    const confirmDelete = async () => {
      try {
        await axios.post(`/api/materials/${materialToDelete.value}/delete`);
        materials.value = materials.value.filter((m) => m.id !== materialToDelete.value);
        showPopupDelete.value = false;
        materialToDelete.value = null;
      } catch (error) {
        console.error("Fehler beim Löschen des Materials:", error.response?.data || error);
      }
    };

    onMounted(() => {
      loadMaterial();
    });

    return {
      materials,
      newMaterial,
      editMaterial,
      showPopupAdd,
      showPopupEdit,
      showPopupDelete,
      addMaterial,
      updateMaterial,
      openEditPopup,
      openDeletePopup,
      confirmDelete,
    };
  },
};

</script>

<style scoped>
.menue {
  background-color: #1f2937;
  width: 40vw;
  padding: 20px;
  border-radius: 5px;
}

.mitarbeiter {
  display: flex;
  flex-direction: column; /* Anordnung der Elemente untereinander */
  align-items: flex-start; /* Links ausgerichtet */
  padding: 10px;
  background-color: #2d3748; /* Etwas dunklerer Hintergrund für die Zeilen */
  margin-bottom: 10px; /* Abstand zwischen den Zeilen */
  border-radius: 8px; /* Abgerundete Ecken */
}


.delete-btn {
  background-color: #dc2626;
  padding: 10px;
  outline: none;
  border: none;
  border-radius: 5px;
  color: white; /* Textfarbe für den Button */
  cursor: pointer;
}

.add-btn {
  background-color: #4f46e5; /* Hintergrundfarbe für den "Material hinzufügen"-Button */
  color: white; /* Textfarbe */
  padding: 10px 20px; /* Innenabstand */
  border: none;
  border-radius: 5px; /* Abgerundete Ecken */
  cursor: pointer;
  margin-top: 20px; /* Abstand nach oben */
}

.edit-btn {
  background-color: #4caf50; /* Grün für den Bearbeiten-Button */
  padding: 10px;
  outline: none;
  border: none;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  margin-right: 10px; /* Abstand zwischen Buttons */
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background-color: #2d3748;
  padding: 20px;
  border-radius: 10px;
  width: 400px;
}

.input-field {
  margin-bottom: 10px;
  padding: 10px;
  width: 100%;
  border: 1px solid #374151;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.1);
  color: #f3f4f6;
}

.button-group {
  display: flex;
  justify-content: space-between;
}

.btn {
  background-color: #4f46e5;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
}

.close-btn {
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
}

.button-container {
  display: flex;
  justify-content: flex-end; /* Buttons werden rechtsbündig angezeigt */
  margin-top: 10px; /* Abstand zwischen Text und Buttons */
}

</style>
